module.exports = __webpack_public_path__ + "images/downloadIcon-0e378cf6761c4e02fafc6bcb3894d234.svg";